<small class="debug">{{me}}</small>
<div [@fadeIn]="getState()">
    <router-outlet></router-outlet>
    <mat-drawer-container>
        <mat-drawer-content>
            <div class="list-container main-container">
                <app-scene-list-details #appList (toggleMinimize)="sidenav.toggle()"></app-scene-list-details>
            </div>
        </mat-drawer-content>
        <mat-drawer [opened]="sidenavOpened" [mode]="sidenavMode" position="end" #sidenav [disableClose]="sidenavMode === 'side'">
            <div class="props-container">
                <app-scene-list-props 
                    [setSelectionModel]="appList.selection" 
                    (deselecting)="appList.onDeselect()" 
                    (deleting)="appList.onDelete()" 
                    (updateSelection)="appList.selection = $event">
                </app-scene-list-props>
            </div>
        </mat-drawer>
    </mat-drawer-container>
</div>
